import { api } from '@/services';
import Vue from 'vue';

function buildURLSearchParams(payload) {
  const params = new URLSearchParams();

  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach((subKey) => {
        params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
      });
    } else if (value) {
      params.append(key, value);
    }
  });

  return params;
}

export default {
  async fetchInventarioItems({ commit, dispatch }, payload) {
    const params = buildURLSearchParams(payload);

    dispatch('toggleLoading', true, { root: true });

    try {
      const { data } = await api.get('/inventario', { params });

      commit('SET_INVENTARIO_TABLE_ITEMS', data.data);
      commit('paginacao/SET_PAGINADOR', data, { root: true });
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }

    dispatch('toggleLoading', false, { root: true });
  },
  async fetchGraficos({ commit }, payload) {
    const params = buildURLSearchParams(payload);

    try {
      const { data } = await api.get('/inventario/graficos', { params });

      const { precisaoInventario, inventarioRealizados, historicoProdutos } = data;

      commit('SET_PRECISAO_INVENTARIO', precisaoInventario);
      commit('SET_INVENTARIOS_REALIZADOS', inventarioRealizados);
      commit('SET_HISTORICO_PRODUTOS_INVENTARIO', historicoProdutos);
    } catch (e) {
      const { response } = e;

      Vue.$toast.clear();
      Vue.$toast.error(response.data.message);
    }
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
};
